import { Link } from "react-router-dom";
import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";
import Avatar from "./Avatar";
import UserBadge from "./UserBadge";

interface Aggregate {
  avg: number;
  count: number;
}

interface SellerInfoProps {
  seller: any;
  aggregate?: Aggregate | null;
  size?: "small" | "large";
}

const SellerInfo: React.FC<SellerInfoProps> = ({
  seller,
  aggregate,
  size = "large",
}) => {
  const sellerProfileUrl = `/seller/${seller?._id}`;
  const hasAggregate = (aggregate?.count ?? 0) > 0;
  const isSmall = size === "small";

  return (
    <div className="sellerInfo d-flex align-items-start gap-3">
      <Avatar
        src={seller?.fileUrl}
        name={seller?.name}
        className={`sellerInfo__img flex-shrink-0 ${
          isSmall ? "sellerInfo__img--small" : "sellerInfo__img--large"
        }`}
      />
      <div
        className="d-flex flex-column gap-2"
        style={{ minWidth: 0 }}
      >
        <Link to={sellerProfileUrl} className="sellerInfo__nameLink">
          <h4 className={`mb-0 ${isSmall ? "sellerInfo__name--small" : ""}`}>
            {seller?.name}
          </h4>
        </Link>
        {seller?.badges?.length > 0 && (
          <div className="d-flex flex-wrap gap-2">
            {seller?.badges?.map((k: string) => (
              <UserBadge key={k} badge={k} size={size} />
            ))}
          </div>
        )}
        {hasAggregate && aggregate && (
          <div className="sellerInfo__rating">
            <Rating
              style={{ maxWidth: 100 }}
              value={aggregate.avg}
              readOnly
            />
            <span className="sellerInfo__ratingText">
              <strong>{aggregate.avg.toFixed(1)}</strong>
              <span className="sellerInfo__ratingSep">·</span>
              {aggregate.count} review
              {aggregate.count === 1 ? "" : "s"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerInfo;
